<template lang="pug">
.alert-box
	.has-text-centered
		.columns.is-mobile.is-centered.is-vcentered.is-multiline.columns-no-padding-vertical.margin-top-xs
			.column.is-narrow
				| {{ $t('home.title_partners2') }}
			.column.is-narrow.no-padding-left
				img(src="/icon.png" alt="" draggable="false" style="width:2rem; display:block;")
			.column.is-narrow.no-padding-left
				strong {{ $t('home.section_intro.app2') }}
		.app-container(style="margin-top: 1.5rem;")
			.columns.column-text-center.is-vcentered.columns-logos
				.column.is-narrow.has-text-centered
					img(src="/img/ferrero_logo2.png" style="height: 30px;display:inline-block;")
				.column.is-narrow.has-text-centered
					img(src="/img/enel_logo_small.png" style="height: 33px;display:inline-block; margin-top: -5px;")
				.column.is-narrow.has-text-centered
					img(src="/img/vodafone_business_small.png" style="height: 38px;display:inline-block;")
				.column.is-narrow.has-text-centered
					img(src="/img/fastweb_small.png" style="height: 38px;display:inline-block;")
			.columns.column-text-center.is-vcentered.columns-logos
				.column.is-narrow.has-text-centered
					img(src="/img/reale_mutua_small.png" style="height: 34px;display:inline-block;")
				.column.is-narrow.has-text-centered
					img(src="/img/findomestic_logo_small.png" style="height: 36px;display:inline-block;")
				.column.is-narrow.has-text-centered
					img(src="/img/jakala_logo.png" style="height: 34px;display:inline-block; margin-top: 5px;")
				.column.is-narrow.has-text-centered
					img(src="/img/jtwia_small.png" style="height: 36px;display:inline-block;")
</template>

<script>
export default {
	name: 'IntroPartners'
}
</script>
